<template>
    <div class="paper-container">
        <div class="paper-title">
            <span>{{ paperTitle }}</span>
            <!-- <div class="switch-btn" v-if="role === 3">
                    <el-radio-group v-model="switchVal" size="small" @input="inputChange">
                        <el-radio-button label="1">允许查看答案</el-radio-button>
                        <el-radio-button label="0">不允许查看答案</el-radio-button>
                    </el-radio-group>
                </div> -->
        </div>
        <div class="score-table" v-if="scoreTableData.length">
            <div class="score-table-main">
                <el-table :data="scoreTableData" border>
                    <el-table-column label="题型" align="center">
                        <template slot-scope="scope">
                            <span>得分</span>
                        </template>
                    </el-table-column>
                    <el-table-column v-for="(value, key) in scoreTableData[0]" width="80" align="center" :key="key"
                        :prop="key" :label="headerLabels[key] || ''" v-if="key !== 'total'"></el-table-column>
                    <el-table-column label="总分" width="80" align="center">
                        <template slot-scope="scope">
                            <span :class="scope.row.total < 60 ? 'red' : ''">{{ scope.row.total }}</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <div class="paper-content">
            <exam-paper-template :data.sync="paperContent" :status="status"></exam-paper-template>
        </div>
        <!-- <div class="paper-btn" v-if="role === 4">
            <el-button type="primary" class="w-120" @click="submitExam">提交</el-button>
            <el-button type="warning" class="w-120" @click="resetExam" v-if="scoreTableData.length">重做</el-button>
        </div> -->
    </div>

</template>

<script>
import _ from "underscore";
import common from "@/utils/common";
import examPaperTemplate from "./examPaperTemplate.vue";
import { setCoursePaperShow, cleanStuData, submitPaperData } from "@/utils/apis"
export default {
    name: "examPaperPreView",
    props: ['paper_id'],
    created() {
        this.examId = this.paper_id;
        this.getExamInfo();
    },
    components: {
        examPaperTemplate
    },
    data() {
        return {
            examId: null,
            paperTitle: '',
            paperContent: {},
            multipleOptions: [],
            role: Number(localStorage.getItem("role")),
            switchVal: 0,
            scoreTableData: [],
            headerLabels: {
                single: "单选题",
                multiple: "多选题",
                judge: "判断题",
                fillBlank: "填空题",
                askAnswer: "问答题",
            },
            status: 0,
        }
    },
    watch: {
        'paper_id'(newValue, old) {
            // console.log(newValue, "pppp");
            this.examId = newValue
            // this.projectInfo()
            this.getExamInfo();
        }
    },
    methods: {
        submitExam() {
            const query = this.$route.query;
            const post_data = {
                data: this.paperContent,
                course_id: query.course_id,
                chapter_index: query.zhangIndex,
                section_index: query.jieIndex,
                paper_id: this.paper_id
            }
            submitPaperData(post_data).then((res) => {
                if (res.code === 200) {
                    this.$message({
                        type: "success",
                        message: res.msg,
                        duration: 1500,
                        onClose: () => this.getExamInfo()
                    })
                } else {
                    this.$message.warning(res.msg)
                }
            }).catch(err => common.axiosErrorMsg(err))
        },
        resetExam() {
            this.$confirm("设置重做之后所有答题记录都会清空，确定继续", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消"
            }).then(() => {
                const query = this.$route.query;
                const data = {
                    course_id: query.course_id,
                    chapter_index: query.zhangIndex,
                    section_index: query.jieIndex,
                    paper_id: this.paper_id
                }
                cleanStuData(data).then(({ code, msg, data }) => {
                    if (code === 200) {
                        this.$message({
                            type: "success",
                            message: msg,
                            duration: 1500,
                            onClose: () => this.getExamInfo()
                        })
                    }
                }).catch(err => {
                    common.axiosErrorMsg(err)
                })


            }).catch()
        },
        translateNum(index) {
            return common.getNumStr(index);
        },
        inputChange(val) {
            const data = {
                course_id: this.$route.query.course_id,
                chapter_index: this.$route.query.zhangIndex,
                section_index: this.$route.query.jieIndex,
                paper_id: this.paper_id,
                is_show: val
            }
            setCoursePaperShow(data).then(({ code, msg, data }) => {
                if (code === 200) {
                    this.$message({
                        type: "success",
                        message: msg,
                        duration: 1500,
                        onClose: () => this.getExamInfo()
                    })
                } else {
                    this.$message.warning(msg);
                }
            })
        },
        getExamInfo() {
            const params = {
                id: this.examId,
                course_id: this.$route.query.course_id,
                chapter_index: this.$route.query.zhangIndex,
                section_index: this.$route.query.jieIndex,
                student_id: this.$route.query.s_id
            }
            this.$thttp.axiosGetBy(this.$api.findTestPaper, params, (res) => {
                if (res.code === 200) {
                    this.paperTitle = res.data.paper_name;
                    let paper_content = JSON.parse(res.data.paper_content);
                    this.switchVal = res.data.is_show;
                    this.scoreTableData = res.data.score_table ?? [];
                    // this.status = (this.switchVal && res.data.score_table) ? 1 : 0;
                    this.status =1;
                    this.paperContent = paper_content;
                }
            })

        }
    }
}
</script>
<style scoped lang="scss">
.score-table {

    &,
    & * {
        box-sizing: border-box;
    }

    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 10px 0;

    .score-table-main {
        padding: 10px;
        background-color: #E5EEFD;

        .red {
            color: red;
        }
    }
}

.w-120 {
    width: 120px;
}

.paper-btn {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 50px;
}

.paper-title {

    &,
    & * {
        box-sizing: border-box;
    }

    position: relative;
    width: 100%;
    height: 70px;
    display: flex;
    justify-content: center;
    align-items: center;

    span {
        font-size: 24px;
        font-weight: bold;
    }

    .switch-btn {
        position: absolute;
        height: 100%;
        top: 0;
        right: 0;
        padding-right: 20px;
    }
}

.paper-wrapper {
    width: 100%;
    height: 100%;

    // background-color: pink;
    /*background: #fff;*/
    ::v-deep .el-scrollbar__wrap {
        overflow-x: hidden;
    }

    .paper-container {
        width: 100%;
        margin: 0 auto;
        background: #fff;
        padding: 30px;
        box-sizing: border-box;

        .paper-title {
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 24px;
            color: #001130;
            line-height: 28px;
            text-align: center;
            font-style: normal;
            text-transform: none;
        }

        .paper-content {
            width: 100%;
            height: 800px;
            margin-top: 30px;

        }
    }
}
</style>
